
import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function preguntarespuestaComboReducer(state= initialState.preguntarespuestaCombo, action){
	switch(action.type){
		case types.GET_PREGUNTARESPUESTAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}